import { showReactUINotification, NotificationType } from '@amusnet/react-ui'
import { GenericNotification } from '@components/BonusSystemCommon'
import { InPlayNotification } from '@components/FreeBuyBonus'
import { useCountdownFSBonusStore } from '@stores/countdownFSBonusStore'
import { useFreeBuyBonusStore } from '@stores/freeBuyBonusStore'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'
import { useConfigurationStore } from '@stores/index'
import { useLuckySpinsStore } from '@stores/luckySpinsStore'
import { useEffect } from 'react'

const useBonusStateNotification = () => {
    const isHistoryMode = useConfigurationStore((state) => state.isHistoryMode)
    const isReplayMode = useConfigurationStore((state) => state.isReplayMode)

    const hasActivatedBonus = useFreeBuyBonusStore((state) => state.hasActivatedBonus)
    const isThereFBBClaimingError = useFreeBuyBonusStore((state) => state.isThereClaimingError)
    const isFBBonusAlreadyClaimed = useFreeBuyBonusStore((state) => state.isBonusAlreadyClaimed)

    const isThereBonusSpinsClaimingError = useFreeSpinsBonusesStore((state) => state.isThereClaimingError)
    const isFSBonusAlreadyClaimed = useFreeSpinsBonusesStore((state) => state.isBonusAlreadyClaimed)
    const isFSRecovery = useFreeSpinsBonusesStore((state) => state.isRecovery)

    const isThereCFSClaimingError = useCountdownFSBonusStore((state) => state.isThereClaimingError)
    const isCFSBonusAlreadyClaimed = useCountdownFSBonusStore((state) => state.isBonusAlreadyClaimed)
    const isStoreCFSRecovery = useCountdownFSBonusStore((state) => state.isRecovery)
    const hasActiveCFSBonusExpired = useCountdownFSBonusStore((state) => state.hasActiveBonusExpired)

    const isLSRecovery = useLuckySpinsStore((state) => state.isRecovery)

    const isThereClaimingError = isThereBonusSpinsClaimingError || isThereFBBClaimingError || isThereCFSClaimingError
    const isBonusAlreadyClaimed = isFSBonusAlreadyClaimed || isFBBonusAlreadyClaimed || isCFSBonusAlreadyClaimed
    const isCFSRecovery = isStoreCFSRecovery && !hasActiveCFSBonusExpired()
    const isRecovery = isFSRecovery || isLSRecovery || isCFSRecovery

    useEffect(() => {
        if (!isHistoryMode && (hasActivatedBonus || isThereFBBClaimingError)) {
            showReactUINotification({
                type: NotificationType.CUSTOM,
                component: <InPlayNotification />,
            })
        }
    }, [hasActivatedBonus, isThereFBBClaimingError])

    useEffect(() => {
        const shouldShowRecovery = isBonusAlreadyClaimed || isThereClaimingError || isRecovery

        if (!isHistoryMode && !isReplayMode && shouldShowRecovery) {
            showReactUINotification({
                type: NotificationType.CUSTOM,
                component: <GenericNotification />,
            })
        }
    }, [isBonusAlreadyClaimed, isThereClaimingError, isRecovery])
}

export default useBonusStateNotification
